class GeolocationError extends Error {
  message!: string

  constructor(message?: string) {
    super(message ?? '브라우저에서 현재위치 정보를 가져오지 못했습니다.')
  }
}

class GeohashValidationError extends Error {}

class UnknownError extends Error {
  constructor(message?: string) {
    super(message ?? '알 수 없는 에러가 발생했습니다.')
  }
}

class NetWorkError extends Error {
  constructor(message = '네트워크 연결이 원활하지 않습니다. 인터넷 연결을 확인해주세요.') {
    super(message)
  }
}

class ClientDataNullError extends Error {
  constructor(message?: string) {
    super(message ?? '데이터가 존재하지 않습니다.')
  }
}

const Errors = {
  GeolocationError,
  GeohashValidationError,
  UnknownError,
  NetWorkError,
  ClientDataNullError
}

export default Errors
